import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import Urbanist from "@fontsource/urbanist";

export default function DisplayProjects(props) {
  const { projectNames } = props;
  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <DataGrid
        columns={[
          {
            field: "projectName",
            headerName: "Projects",
            width: 500,
            editable: false,
            headerAlign: "center",
          },
        ]}
        rows={projectNames.map((name, index) => ({
          projectName: name,
          id: index,
        }))}
        disableSelectionOnClick
        sx={{
          ".MuiDataGrid-columnSeparator": {
            display: "none",
          },
          ".MuiDataGrid-columnHeaders": {
            color: "#3299FF",
            fontSize: 18,
            fontWeight: "bold",
            font: { Urbanist },
          },
          ".MuiDataGrid-row:hover": {
            backgroundColor: "inherit", // Or 'transparent' or whatever color you'd like
          },
        }}
      ></DataGrid>
    </Box>
  );
}
DisplayProjects.propTypes = {
  projectNames: PropTypes.array.isRequired,
};
